import { manipulateDigitalData } from '@ao-internal/digital-data';

import { UPDATE_DOCUMENT_INFORMATION } from '../actions/lister-actions';

export function updateDocumentTitle(title) {
	const hostname = window.location.hostname;
	if (title) {
		const documentTitle = `${title} | ${hostname}`.replace('  ', ' ');

		document.title = documentTitle;
		return;
	}

	document.title = hostname;
	return;
}

export function updateMetaDescription(description) {
	if (description) {
		const metaDescriptionElement = document.querySelector(
			'meta[name="description"]'
		);

		if (!metaDescriptionElement) return;

		metaDescriptionElement.setAttribute('content', description);
	}

	return;
}

export function updateCanonical(link) {
	if (link) {
		const canonical = document.querySelector('link[rel="canonical"]');

		if (!canonical) return;

		canonical.setAttribute('href', link);
	}

	return;
}

export function updateDigitalData({ CategorisationTagViewModel }) {
	if (!CategorisationTagViewModel) {
		return;
	}

	const {
		ApplianceType,
		HighLevelCategory,
		MainCategory,
		SubCategory,
	} = CategorisationTagViewModel;

	manipulateDigitalData({
		page: {
			productDiscovery: {
				listerPage: {
					applianceType: ApplianceType,
				},
			},
			pageInfo: {
				mainCategory: HighLevelCategory,
				subCategory: MainCategory,
				realSubCategory: SubCategory,
			},
		},
	});
}

export const updateDocumentInformation = (store) => (next) => (action) => {
	next(action);

	const {
		pageTitle,
		pageDescription,
		canonical,
		adobeTagging,
		drawer: { drawerOpen } = {},
	} = store.getState();

	switch (action.type) {
		case UPDATE_DOCUMENT_INFORMATION:
			if (drawerOpen) {
				return;
			}

			updateDocumentTitle(pageTitle);
			updateMetaDescription(pageDescription);
			updateCanonical(canonical);
			updateDigitalData(adobeTagging);

			break;

		default:
			break;
	}
};
